import React from 'react';
import { Tabs, TabsProps } from '@mantine/core';

export interface ConfigTabItem {
    value: string;
    label: string;
    icon?: React.ReactNode;
    color?: string;
    rightSection?: React.ReactNode;
}

interface ConfigTabsProps extends Omit<TabsProps, 'children'> {
    tabs: ConfigTabItem[];
    children: React.ReactNode;
}

export function ConfigTabs({ tabs, children, ...others }: ConfigTabsProps) {
    return (
        <Tabs
            variant="pills"
            color="black"
            radius="md"
            classNames={{
                tab: 'transition-all duration-200 font-medium shrink-0',
                list: 'flex flex-nowrap overflow-x-auto hide-scrollbar bg-black/[0.02] dark:bg-white/[0.02] p-1 rounded-md border border-black/[0.05] dark:border-white/[0.05]'
            }}
            styles={{
                tab: {
                    // Static styles only
                },
                list: {
                    // Static styles only
                }
            }}
            {...others}
        >
            <Tabs.List mb="md">
                {tabs.map((tab) => (
                    <Tabs.Tab
                        key={tab.value}
                        value={tab.value}
                        leftSection={tab.icon}
                        color={tab.color}
                        rightSection={tab.rightSection}
                    >
                        {tab.label}
                    </Tabs.Tab>
                ))}
            </Tabs.List>
            {children}
        </Tabs>
    );
}
